import { datePresets } from 'client/modules/Surveys/components/SearchDateRange/SearchDateRangeControl';
import moment from 'moment';

/** Daily buckets are capped to keep Activity aggregations fast. */
export const DELIVERY_DAY_MAX_DAYS = 62;
export const DELIVERY_WEEK_MAX_DAYS = 366;

function resolveBoundary(value) {
  if (!value) {
    return null;
  }
  const presets = datePresets();
  if (presets[value]) {
    return presets[value].clone();
  }
  const parsed = moment(value, ['YYYY-MM-DD', moment.ISO_8601], true);
  return parsed.isValid() ? parsed : null;
}

/** Inclusive day count for the selected audience range; null when open-ended (all time). */
export function estimateDeliveryRangeDays(since, until) {
  const start = resolveBoundary(since);
  if (!start) {
    return null;
  }
  const end = resolveBoundary(until) || moment();
  return Math.max(1, end.endOf('day').diff(start.startOf('day'), 'days') + 1);
}

export function getDeliveryIntervalOptions(rangeDays) {
  if (rangeDays == null) {
    return { defaultInterval: 'month', allowed: ['month'] };
  }
  const allowed = ['month'];
  if (rangeDays <= DELIVERY_WEEK_MAX_DAYS) {
    allowed.unshift('week');
  }
  if (rangeDays <= DELIVERY_DAY_MAX_DAYS) {
    allowed.unshift('day');
  }
  let defaultInterval = 'month';
  if (rangeDays <= DELIVERY_DAY_MAX_DAYS) {
    defaultInterval = 'day';
  } else if (rangeDays <= DELIVERY_WEEK_MAX_DAYS) {
    defaultInterval = 'week';
  }
  return { defaultInterval, allowed };
}

export function coerceDeliveryInterval(interval, rangeDays) {
  const { allowed, defaultInterval } = getDeliveryIntervalOptions(rangeDays);
  return allowed.includes(interval) ? interval : defaultInterval;
}
